var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 暂未有人发题解捏 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }